import { render, staticRenderFns } from "./dashboard-hourly.vue?vue&type=template&id=20e985b5&scoped=true"
import script from "./dashboard-hourly.vue?vue&type=script&lang=js"
export * from "./dashboard-hourly.vue?vue&type=script&lang=js"
import style0 from "./dashboard-hourly.vue?vue&type=style&index=0&id=20e985b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e985b5",
  null
  
)

export default component.exports